import api from '../index'

export default {
  // 后端获取路由数据
  routeList: () => api.get('/user/route/list'),

  // 基于文件系统路由模式下，后端获取导航菜单数据
  menuList: () => api.get('user/menu/list'),

  // 获取用户语言偏好设置
  getUserLocale: () => api.get('app/user/locale'),
}
